<div class="container-fluid">
    <div class="row d-flex">
        <div class="col-lg-12">
            <br/>
            <h3>Welcome to PATEMPO™!</h3>
            <div class="welcome">
                <p>PATEMPO™ responds to a critical question that any patent applicant or agent has: <strong>“Assuming I can obtain a patent, how long will it take to get granted?”.</strong> It allows to automatically estimate the pendency of your patent applications in China and South-East Asia and to instantly access to our recommendations on how to expedite their examination, publication and grant.</p>            </div>
        </div>
    </div>
</div>
<div class="container-fluid px-1 px-md-5 px-lg-1 px-xl-5 py-5 mx-auto" style="width: 50%">
    <div class="card card0 border-0">
        <div class="row d-flex">
            <div class="col-lg-12">
                <div class="card2 card border-0 px-4 py-5">
                    <div class="row mb-4 px-3" style="margin-bottom:0!important;">
                        <div class="card1 pb-5">
                            <div class="row"><h1 class="text-center"><img src="logo-patempo.png" height="35" alt="" style="margin-left:12px;" /></h1> </div>
                        </div>
                    </div>
                    <div class="row px-3 mb-4">
                        <div class="line"></div>
                        <div class="line"></div>
                    </div>

                    <form #form='ngForm' class="mb-4" autocomplete="off" (submit)="onSubmit(form)">
                        <ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="default" color="#fff" type="ball-spin-clockwise-fade" [fullScreen]="false"></ngx-spinner>
                        <div class="row px-3">
                            <label class="mb-1">
                                <h6 class="mb-0 text-sm">Email Address</h6>
                            </label>
                            <input class="mb-4" #UserName="ngModel" name="UserName" [(ngModel)]="formModel.UserName" required>

                        </div>
                        <div class="row px-3">
                            <label class="mb-1">
                                <h6 class="mb-0 text-sm">Password</h6>
                            </label>
                            <input type="password" #Password="ngModel" name="Password" [(ngModel)]="formModel.Password" required autocomplete="off">
                        </div>
                        <div class="row px-3 mb-4">
                            <a href="#" [routerLink]="['/forgot-password']" class="ms-auto mb-0 text-sm">Forgot Password?</a>
                        </div>
                        <div class="row mb-3 px-3"> <button type="submit" class="btn btn-blue text-center">Login</button> </div>
                    </form>
                    <div class="row mb-4 px-3">
                        <small class="font-weight-bold">
                            Don't have an account?
                            <a class="text-danger " [routerLink]="['/registration']">Register</a>
                        </small>
                    </div>
                </div>
            </div>
        </div>

    </div>
</div>
